<template>
  <transition name="fade">
    <div v-if="props.shown" class="cover-loader" />
  </transition>
</template>

<script setup lang="ts">
const props = defineProps<{
  shown: boolean;
}>();
</script>

<style scoped lang="scss">
.cover-loader {
  position: absolute !important;
  z-index: 10;
  inset: 0;

  @include disable-loader;
}
</style>
